import React, { useState } from "react";
import { setDevRoleOverride, clearDevRoleOverride, UserRole } from "../../hooks/useRole";

interface Preset {
  label: string;
  role: UserRole;
  can_prescribe: boolean;
  color: string;
}

const PRESETS: Preset[] = [
  { label: "Admin ✓KYC",    role: "Admin",         can_prescribe: true,  color: "#7c3aed" },
  { label: "Admin no-KYC",  role: "Admin",         can_prescribe: false, color: "#b45309" },
  { label: "Doctor",        role: "Doctor",        can_prescribe: true,  color: "#0369a1" },
  { label: "Reception",     role: "Receptionist",  can_prescribe: false, color: "#065f46" },
  { label: "PlatformAdmin", role: "PlatformAdmin", can_prescribe: false, color: "#9f1239" },
];

function readCurrentOverride(): string {
  try {
    const raw = localStorage.getItem("kaagazy_dev_role_override");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    return parsed.role ?? "";
  } catch {
    return "";
  }
}

const DevRoleSwitcher: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(() => readCurrentOverride());

  const apply = (preset: Preset) => {
    setDevRoleOverride(preset.role, preset.can_prescribe);
    setActive(preset.role);
    window.location.reload();
  };

  const clear = () => {
    clearDevRoleOverride();
    setActive("");
    window.location.reload();
  };

  return (
    <div style={{ position: "fixed", bottom: 16, right: 16, zIndex: 9999, fontFamily: "monospace" }}>
      {open && (
        <div style={{
          marginBottom: 8,
          background: "#1e1e2e",
          border: "1px solid #3f3f5a",
          borderRadius: 10,
          padding: "10px 12px",
          minWidth: 185,
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        }}>
          <div style={{ color: "#94a3b8", fontSize: 10, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.08em" }}>
            Dev · Switch Role
          </div>
          {PRESETS.map((p) => {
            return (
              <button
                key={p.label}
                onClick={() => apply(p)}
                style={{
                  display: "block",
                  width: "100%",
                  marginBottom: 4,
                  padding: "6px 10px",
                  background: p.color + (active === p.role ? "44" : "22"),
                  border: `1px solid ${p.color}${active === p.role ? "99" : "55"}`,
                  borderRadius: 6,
                  color: "#e2e8f0",
                  fontSize: 12,
                  fontFamily: "monospace",
                  cursor: "pointer",
                  textAlign: "left",
                  fontWeight: active === p.role ? 700 : 400,
                }}
              >
                {p.label}
              </button>
            );
          })}
          {active && (
            <button
              onClick={clear}
              style={{
                display: "block",
                width: "100%",
                marginTop: 6,
                padding: "5px 10px",
                background: "transparent",
                border: "1px solid #3f3f5a",
                borderRadius: 6,
                color: "#64748b",
                fontSize: 11,
                fontFamily: "monospace",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              ✕ clear override
            </button>
          )}
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          background: active ? "#1e1e2e" : "#1e1e2e",
          border: `1px solid ${active ? "#7c3aed" : "#3f3f5a"}`,
          borderRadius: 8,
          color: active ? "#c4b5fd" : "#94a3b8",
          fontSize: 11,
          fontFamily: "monospace",
          padding: "5px 10px",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}
      >
        🎭 {active || "role"}
      </button>
    </div>
  );
};

export default DevRoleSwitcher;
